export class ProductFixed {
	private readonly element: HTMLElement | null;
	private readonly buyButton = document.querySelector('.product-info__add-to-cart');
	private readonly activeClass = 'product-fixed--active';

	private observer: IntersectionObserver | null = null;

	private prevY = 0;
	private wasVisible = true;

	constructor(element: HTMLElement | null) {
		this.element = element;
		this.init();
	}

	private handleIntersect = (entries: IntersectionObserverEntry[]): void => {
		entries.forEach((entry) => {
			const y = entry.boundingClientRect.y;
			const isVisible = entry.isIntersecting;

			const scrollingDown = y < this.prevY;
			const scrollingUp = y > this.prevY;

			if (!isVisible && this.wasVisible && scrollingDown) this.onShow();

			if (isVisible && !this.wasVisible && scrollingUp) this.onHide();

			this.wasVisible = isVisible;
			this.prevY = y;
		});
	};

	protected onHide = (): void => this.element.classList.remove(this.activeClass);
	protected onShow = (): void => this.element.classList.add(this.activeClass);

	public init = (): void => {
		if (!this.element || !this.buyButton) return;

		this.observer = new IntersectionObserver(this.handleIntersect, {
			root: null,
			rootMargin: '0px',
			threshold: 0,
		});

		this.observer.observe(this.buyButton);
	};

	public destroy = (): void => {
		this.observer?.disconnect();
		this.observer = null;
	};
}
